import { Platform } from "react-native";
import { NitroModules } from "react-native-nitro-modules";
import { rethrowNativeError } from "../nativeError";
import { DeviceAttestation as unavailableDeviceAttestation } from "./unavailable";
var hybrid;
function native() {
  if (Platform.OS !== "ios") throw new Error("DeviceAttestation requires an iOS native build");
  hybrid !== null && hybrid !== void 0 ? hybrid : hybrid = NitroModules.createHybridObject("OneDeviceAttestation");
  return hybrid;
}
function getAvailability() {
  try {
    return native().getAvailability();
  } catch (error) {
    return rethrowNativeError(error);
  }
}
function generateKey() {
  return native().generateKey().catch(rethrowNativeError);
}
function attestKey(keyId, clientDataHashBase64) {
  return native().attestKey(keyId, clientDataHashBase64).catch(rethrowNativeError);
}
function generateAssertion(keyId, clientDataHashBase64) {
  return native().generateAssertion(keyId, clientDataHashBase64).catch(rethrowNativeError);
}
function generateDeviceToken() {
  return native().generateDeviceToken().catch(rethrowNativeError);
}
var nativeDeviceAttestation = Object.freeze({
  getAvailability,
  generateKey,
  attestKey,
  generateAssertion,
  generateDeviceToken
});
var DeviceAttestation = Platform.OS === "android" ? unavailableDeviceAttestation : nativeDeviceAttestation;
export {
  DeviceAttestation
};
//# sourceMappingURL=index.native.js.map
